var React = require('react');

function MapInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M128 64a40 40 0 1 0 40 40a40 40 0 0 0-40-40m0 64a24 24 0 1 1 24-24a24 24 0 0 1-24 24m0-112a88.1 88.1 0 0 0-88 88c0 31.4 14.51 64.68 42 96.25a254.2 254.2 0 0 0 41.45 38.3a8 8 0 0 0 9.18 0a254.2 254.2 0 0 0 41.37-38.3c27.45-31.57 42-64.85 42-96.25a88.1 88.1 0 0 0-88-88m0 206c-16.53-13-72-60.75-72-118a72 72 0 0 1 144 0c0 57.23-55.47 105-72 118"}));
}

MapInline.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 256 256"};

module.exports = MapInline;

MapInline.default = MapInline;
